export const GRETA_AI_CHAT_PROJECTS_PAGE_SKELETON_COUNT = 4

export const QA_NAME_GRETA_AI_CHAT_PROJECTS_PAGE_SKELETON =
  'gretaAIChatProjectsPageSkeleton'
